"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/util/isArrayLike.js
// module id = ../../../../rxjs/util/isArrayLike.js
// module chunks = 16